module.exports = __webpack_public_path__ + "img/08165642000667.7cdb2590.png";